import React from 'react';

interface IProps {
    children: React.ReactNode;
    hasGradientHeader?: boolean;
}

export default function PageLayout(props: IProps) {
    const { children, hasGradientHeader } = props;

    return (
        <div className='bg-default h-full'>
            {/* Make scrolling up show gradient instead of white background */}
            <div className='bg-gradient-dark h-16 -mt-16' />
            {/* Set min height to screen height subtracting header and footer */}
            <div className='flex flex-col' style={{ minHeight: 'calc(100vh - 3.5rem - 2rem)' }}>
                {hasGradientHeader ? (
                    <div className='flex-1 relative flex flex-col justify-between'>
                        <div className='bg-gradient-dark absolute top-0 w-full h-80' />
                        <div className='flex-1 flex flex-col z-10'>{children}</div>
                    </div>
                ) : (
                    children
                )}
            </div>
        </div>
    );
}
